import { useEffect, useState } from 'react'
import { ModalStore } from '../../state/ModalStore'
// import CancelButton from '../Buttons/CancelButton'
// import { Primary } from '../Buttons/Primary'
import ErrorAlert from '../Alerts/ErrorAlert'
// import { CustomerAPI, CustomerFetcher } from '../../apis/CustomerAPI'
// import useSWR from 'swr'
import ModalContent from './ModalContent'
import ModalContentWrapper from './ModalContentWrapper'
import ModalHeader from './ModalHeader'
import ModalFooter from './ModalFooter'
import { log } from '../../helpers/utils'
import TemplatesComponent from '../TemplatesComponent'
import ModalMainWrapper from './ModalMainWrapper'
// import { useRouter } from 'next/router'

export const selectTemplateId = 'select-template-modal'

const SelectTemplateModal = ({
    setValue,
    getValues,
    afterSelection,
    templates_and_attributes,
    item,
    templateIndustries,
}) => {
    const skimModal = ModalStore((state) => state.skim)

    const [error, setError] = useState(null)
    const [prevSelected, setPrevSelected] = useState(null)

    // const router = useRouter()

    const onSelect = (value) => {
        setValue(item.name, value)
        // if (router.query?.template && router.query?.templateName) {
        //     afterSelection(value)
        //     setTimeout(() => {
        //         onChooseDesign()
        //     }, 10)
        //     // skimModal()
        // }
    }

    const onChooseDesign = () => {
        const value = getValues(item.name)
        const isValidValue = value && value?.length !== 0 && value != null

        if (!isValidValue) {
            setError('Please select a template.')
            return
        } else {
            afterSelection(value)
            setError(null)
            setTimeout(() => {
                skimModal()
            }, 0)
        }
    }

    const handleCancel = () => {
        // if(!prevSelected){
        //     if(item?.parent_field){
        //         setValue(item.parent_field, null)
        //     }
        // }
        // log('SelectTemplateModal', getValues())
        skimModal()
        setValue(item.name, prevSelected)
    }

    const handleMount = () => {
        log('SelectTemplateModal', item)
        setPrevSelected(getValues(item.name))
    }

    useEffect(() => {
        handleMount()
    }, [])

    return (
        <ModalMainWrapper>
            <ModalContentWrapper size="5xl">
                <ModalHeader title={'Templates'} />
                <ModalContent spacing="normal" scroll={true}>
                    <TemplatesComponent
                        templates_and_attributes={templates_and_attributes}
                        templateIndustries={templateIndustries}
                        noOfColumns={5}
                        canUpload={true}
                        canSelect={true}
                        onSelect={onSelect}
                        selected={getValues(item.name)}
                        showTitle={true}
                    />
                    {error && <ErrorAlert error={error} />}
                </ModalContent>

                <ModalFooter
                    onCancel={handleCancel}
                    confirmText="Select Template"
                    onConfirm={onChooseDesign}
                />

                {/* {!customer && customerError && (
                                        <div className="flex justify-between mt-4 ">
                                            Please login to use this feature.
                                        </div>
                                    )} */}
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}

SelectTemplateModal.id = selectTemplateId

export default SelectTemplateModal
